import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  iconColor,
  iconBgColor,
  trend,
  loading = false 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg p-4 md:p-6 shadow-warm border border-border animate-pulse">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="h-4 bg-muted rounded w-24 mb-3"></div>
            <div className="h-8 bg-muted rounded w-32 mb-2"></div>
            <div className="h-3 bg-muted rounded w-20"></div>
          </div>
          <div className="w-12 h-12 bg-muted rounded-xl"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg p-3 sm:p-4 md:p-6 shadow-warm hover:shadow-warm-md transition-smooth border border-border">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="caption text-muted-foreground mb-1 md:mb-2 truncate">{title}</p>
          <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-foreground mb-1 md:mb-2 data-text break-words">
            {value}
          </h3>
          {change && (
            <div className="flex items-center gap-1">
              <Icon 
                name={getTrendIcon()} 
                size={14} 
                className={getTrendColor()}
              />
              <span className={`caption font-medium ${getTrendColor()}`}>
                {change}
              </span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 md:w-14 md:h-14 rounded-xl ${iconBgColor} flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={24} className={iconColor} />
        </div>
      </div>
    </div>
  );
};

export default KPICard;